import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ChatComponent } from './chat.component';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { ChatRoomComponent } from './chat-room/chat-room.component';
import { ChatListMessagesComponent } from './chat-list-messages/chat-list-messages.component';
import { ChatHeadComponent } from './chat-head/chat-head.component';
import { ChatFooterComponent } from './chat-footer/chat-footer.component';
import { RouterModule, Routes } from '@angular/router';
import { FirstLettersPipe } from './first-letters.pipe';
import { AvatarColorPipe } from './avatar-color.pipe';
import { DateMessagePipe } from './date-message.pipe';
import { DateMessageNewPipe } from './date-message-new.pipe';
import { NzModalCreateChatComponent } from './modals/create-chat/create-chat.component';
import { NzModalDeleteChatComponent } from './modals/delete-chat/delete-chat.component';
import { ChatMessageStatusComponent } from './chat-message-status/chat-message-status.component';
import { JitsiModule } from '../../global-components/jitsi/jitsi.module';
import { NzSpinModule } from "ng-zorro-antd/spin";
import { ChatMessageSystemComponent } from './chat-message-system/chat-message-system.component';
import { SystemMessageInitPipe } from './system-message-init.pipe';
import { BalanceModule } from '../../global-components/balance/balance.module';

const routes: Routes = [
  { path: 'chat',
    pathMatch: 'full',
    canActivate: [], // AuthGuard
    component: ChatComponent
  },
];

@NgModule({
  declarations: [
    ChatComponent,
    ChatMessageComponent,
    ChatRoomComponent,
    ChatListMessagesComponent,
    ChatHeadComponent,
    ChatFooterComponent,
    FirstLettersPipe,
    AvatarColorPipe,
    DateMessagePipe,
    DateMessageNewPipe,
    NzModalCreateChatComponent,
    NzModalDeleteChatComponent,
    ChatMessageStatusComponent,
    ChatMessageSystemComponent,
    SystemMessageInitPipe,
  ],
  imports: [
    RouterModule.forChild(routes),
    SharedModule,
    JitsiModule,
    NzSpinModule,
    BalanceModule,
  ],
  providers: [],
  bootstrap: []
})
export class ChatModule { }
